import Resource from './resource';

export default class Message extends Resource {
  constructor(client, id) {
    super(client, 'message', id);
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/message.js
// module id = 38
// module chunks = 0